module.exports = __webpack_public_path__ + "assets/media/november.c0136f30.png";